<template>
  <div class="headerProduct">
    <h1>{{ $t('product.label.list.title') }}</h1>
    <v-data-Table :headers="headers" :items="filteredProducts()" :header-props="{ class: 'red-header' }"
      :search="searchTerm" :no-data-text="$t('chart.label.notData') || 'No hay datos disponibles'" :footer-props="{ 'items-per-page-text': $t('label.rowsPerPage.title') }">
      <!-- Sección superior de la tabla -->
      <template v-slot:top>
        <div style="margin-bottom: 50px">
          <div class="row justify-space-between mx-auto no-padding">
            <div class="col-md-5">
              <v-text-field 
                :label="$t('label.search.title')"
                :placeholder="$t('label.search.text')" 
                append-icon="mdi-magnify" dense
                outlined @input="search">
              </v-text-field>

              <v-select 
                v-model="selectedMode" 
                :items="modeOptions" 
                :label="$t('product.label.mode.title')" 
                :placeholder="$t('product.label.mode.text')" 
                dense outlined
                @change="filterByMode">
              </v-select>

            </div>

            <div class=" no-padding">
              <addProduct />
            </div>
          </div>
        </div>

      </template>

      <template v-slot:[`item.icono`]="{ item }">
        <img :src="item.icono" />
      </template>

      <template v-slot:[`item.nombre`]="{ item }">
        <span class="custom-font">{{ item.nombre }}</span>
      </template>

      <template v-slot:[`item.nameSupplier`]="{ item }">
        <span class="custom-font">{{ item.nameSupplier }}</span>
      </template>

      <template v-slot:[`item.modo`]="{ item }">
        <span class="custom-font">{{ item.modo }}</span>
      </template>

      <template v-slot:[`item.contactoProducto`]="{ item }">
        <span class="custom-font">{{ item.contactoProducto }}</span>
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <!-- Botón de acción para abrir el diálogo de detalles  -->
        <v-icon color="primary" size="x-large"></v-icon>
        <div class="actions">
          <detailProduct :productProps="item" />

          <v-btn class="btnDetails" icon x-large dark text @click="deleteProduct(item.idProducto, item.idModo)"
            style="background-color: transparent; margin-left:1vh">
            <v-icon color="primary">mdi-delete</v-icon>
          </v-btn>
        </div>

      </template>

    </v-data-Table>
  </div>
</template>


<script>
import EventBus from '@/utils/event_bus.js';
import addProduct from '@/views/products/pages/add_products/add_products_page.vue';
import detailProduct from "@/views/products/pages/detail_product/detail_product_page.vue";
import { mapActions, mapGetters } from "vuex";
import i18n from '@/plugins/i18n';
import Swal from "sweetalert2";

import {
  PRODUCTS_M,
  GET_PRODUCTS,
  ACTION_DIALOG_ACTIVE,
  ACTION_DELETE_DELETE_PRODUCTS,
  ACTION_GET_PRODUCTS,

} from "@/views/products/store/types/types.js";

import {
  BOARD_M,
  GET_MODO,
  ACTION_GET_MODE,
} from "@/views/categories_board/store/types/types.js";

export default {
  name: "listProductsComponent",
  components: {
    addProduct,
    detailProduct,
  },

  data() {
    return {
      searchTerm: "",
      roleId: sessionStorage.getItem("roleId"),
      modeOptions: [],
      selectedMode: null,
    };
  },


  async mounted() {
    await this.getMode();


    const pizarraMode = this.modes.find(mode => mode.idModoCategoria === 2);

    if (this.roleId !== "1") {
      if (pizarraMode) {
        this.modeOptions = [
          { text: pizarraMode.nombre, value:null}
        ];
      }
    }
      else
        this.modeOptions = [
          { text: 'Todos', value: null },
          ...this.modes.map(mode => ({
            text: mode.nombre,
            value: mode.idModoProducto
          }))
        ];
        this.selectedMode = this.modeOptions[0].value;


    await this.actionGetProducts(this.selectedMode);
    // id del modo
    await this.getMode();
    const modos = await this.modes
    const id = modos[1].idModoProducto

    await this.actionGetProducts(id)

    if (this.modeOptions.length > 0) {
      this.selectedMode = this.modeOptions[0].value;
      await this.actionGetProducts(this.selectedMode);
    }

    EventBus.$on('form-submit-products', () => {
      // recarga la lista de productos cuando se crea uno
      this.actionGetProducts(id)

    });

    EventBus.$on('reload-update-product', () => {
      this.actionGetProducts(id);
    });

  },

  methods: {

    search() {
      // Actualiza el término de búsqueda
      this.searchTerm = event.target.value;
    },

    isSuperAdmin() {
      if (this.roleId !== "1") {
        this.selectedMode = 2;
      }
    },

    filterByMode() {
      this.actionGetProducts(this.selectedMode);
    },

    filteredProducts() {
      const normalizedSearchTerm = this.searchTerm.toLowerCase();

      return this.copiedProducts().filter(product => {
        const matchesMode = this.selectedMode ? product.modo === this.selectedMode : true;
        const matchesSearchTerm = product.nombre.toLowerCase().includes(normalizedSearchTerm) ||
          product.nameSupplier.toLowerCase().includes(normalizedSearchTerm) || product.modo.toLowerCase().includes(normalizedSearchTerm) ||
          product.contactoProducto.toLowerCase().includes(normalizedSearchTerm);
        return matchesMode && matchesSearchTerm;
      });
    },

    ...mapActions({

      getMode: `${BOARD_M}${ACTION_GET_MODE}`,
      setActiveDialog: `${PRODUCTS_M}${ACTION_DIALOG_ACTIVE}`,
      actionGetProducts: `${PRODUCTS_M}${ACTION_GET_PRODUCTS}`,
      deleteActionProduct: `${PRODUCTS_M}${ACTION_DELETE_DELETE_PRODUCTS}`,
    }),

    copiedProducts() {

      if (Array.isArray(this.products)) {
        return this.products;
      } else if (typeof this.products === 'object') {
        return Object.values(this.products);
      } else {
        return [];
      }
    },

    async deleteProduct(idProducto, idModo) {

      const modoIdproduct = {};
      modoIdproduct.idModo = idModo;
      modoIdproduct.idProducto = idProducto;

      const result = await Swal.fire({
        title: i18n.t('label.delete.title'),
        text: i18n.t('label.delete.text'),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: i18n.t('button.delete.accept'),
        cancelButtonText: i18n.t('button.delete.cancel'),
        confirmButtonColor: "#6E17A5"
      });
      if (result.isConfirmed) {
        await this.deleteActionProduct(modoIdproduct)
        this.actionGetProducts()
      } else {
        Swal.fire({
          position: 'top-end',
          icon: 'info',
          title: i18n.t('label.delete.cancel'),
          showConfirmButton: false,
          timer: 2500
        });
      }
    },
  },

  computed: {
    ...mapGetters({
      modes: [`${BOARD_M}${GET_MODO}`],
      products: [`${PRODUCTS_M}${GET_PRODUCTS}`],

    }),

    headers() {
      return [
        {
          value: "icono",
          align: "center",
          sortable: false,
          class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          text: this.$t('product.label.table.name'),
          value: "nombre",
          align: "center",
          sortable: false,
          class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          text: this.$t('product.label.table.supplier'),
          value: "nameSupplier",
          align: "center",
          sortable: false,
          class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1"
        },
        {
          text: this.$t('product.label.table.type'),
          value: "modo",
          align: "center",
          sortable: false,
          class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          text: this.$t('product.label.table.contact'),
          value: "contactoProducto",
          align: "center",
          sortable: false,
          class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          //text: "Acciones",
          value: "action",  // Cambiado de 'action' a 'actions'
          sortable: false,
          align: "center",
          //class: "primary--text custom-header mdi-pencil text-subtitle-1",
        },
      ];
    },

  },

};
</script>

<style lang="css" scoped>
.headerProduct {
  display: flex;
  gap: 40px;
  flex-direction: column;
  margin-top: 20px;
  margin-left: 20px;
}

.custom-font {
  font-size: 20px;
}

.v-data-table {
  padding: 0 !important;
}

/* Define los estilos (Tipo de letra) para las etiquetas h1,h2,h3,h4,h5,h6   */
body {
  font-family: "Nunito Sans", sans-serif;
}

.headerProduct h1 {
  margin-bottom: 30px;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Amsi Pro", sans-serif;
  color: #2d0049;
  font-weight: normal;
}

.btnDetails .v-icon {
  color: #6E17A5;
  margin-bottom: 19px;
}

.actions {
  display: flex;
  justify-content: center;
  align-items: center;
}

img {
  width: 3rem;
  height: 3rem;

}

@media screen and (max-width: 414px) {

  h1 {
    font-size: 3vh;
    margin-left: 2vh
  }
}

@media screen and (min-width: 414px) {

  h1 {
    font-size: 4vh;
    margin-left: 2vh
  }
}

@media screen and (max-width: 280px) {

  h1 {
    font-size: 3vh;
    margin-left: 2vh
  }

  h2 {
    font-size: 2vh;
  }
}
</style>